import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/sections/Marquee";
import { Problem } from "@/components/sections/Problem";
import { Solution } from "@/components/sections/Solution";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { Outcomes } from "@/components/sections/Outcomes";
import { EmployeeBenefits } from "@/components/sections/EmployeeBenefits";
import { WhyJetSeat } from "@/components/sections/WhyJetSeat";
import { LeadForm } from "@/components/sections/LeadForm";
import { Corporate } from "@/components/sections/Corporate";
import { Partnership } from "@/components/sections/Partnership";
import { Faq } from "@/components/sections/Faq";
import { ResourcesTeaser } from "@/components/sections/ResourcesTeaser";
import { useLenis } from "@/hooks/useLenis";
import { useSEO } from "@/hooks/useSEO";
import { useI18n } from "@/i18n";
import { useEffect } from "react";

export default function Landing() {
  useLenis();
  const { lang } = useI18n();
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 400);
    }
  }, []);
  useSEO({
    title: lang === "it"
      ? "JetSeat - Mobilità Business Aziendale con Voli Privati Dedicati"
      : "JetSeat - Corporate Business Mobility with Dedicated Private Flights",
    description: lang === "it"
      ? "JetSeat progetta e gestisce programmi di mobilità business per aziende: voli privati dedicati su rotte ricorrenti, accordi quadro e posti garantiti prepagati con operatori certificati."
      : "JetSeat designs and runs corporate business mobility programs: dedicated private flights on recurring routes, framework agreements and prepaid guaranteed seats with certified operators.",
  });
  return (
    <div className="bg-background" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Problem />
        <Solution />
        <HowItWorks />
        <Outcomes />
        <EmployeeBenefits />
        <WhyJetSeat />
        <Corporate />
        <LeadForm />
        <Partnership />
        <ResourcesTeaser />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
